import Loadable from 'app/components/Loadable';
import { lazy } from 'react';


// const SavedArtist = Loadable(lazy(() => import('./SavedArtist')));
// const SavedCasting = Loadable(lazy(() => import('./SavedCasting')));
const SavedPost = Loadable(lazy(() => import('./SavedPost')));
 const SavedApplyJob = Loadable(lazy(() => import('./SavedApplyJob')));
const SavedPostv1 = Loadable(lazy(() => import('./SavedPostv1')));





const SavedRoutes = [
  // { path: '/saved/saved-artist', element: <SavedArtist /> },
  // { path: '/saved/saved-casting', element: <SavedCasting /> },
  { path: '/saved/saved-post', element: <SavedPost /> },
   { path: '/saved/apply-job/:mode/:id', element: <SavedApplyJob /> },
  { path: '/saved/SavedPostv1', element: <SavedPostv1 /> },




];

export default SavedRoutes;